import React from "react";
import SectionFooter from "../../components/SectionFooter";
import useController from "./controller";
import { Outlet } from "react-router-dom";
import BaseSpinner from "../../components/BaseSpinner";
import AlreadyUsedLink from "../../modals/AlreadyUsedLink";
import { isPWA, isWebView } from "../../utils/helpers";
import MobileAppSectionHeader from "./components/MobileAppSectionHeader";
import MobileAppSectionMainTitle from "./components/MobileAppSectionMainTitle";
import "./style.scss";
import "./mobileAppStyle.scss";

import Ellipses from "../../components/Ellipses";
import PwaAndAppAuthGuard from "../../hocs/PwaAndAppAuthGuard";
import GenderNotification from "../../modals/GenderNotification";

function LandingPage() {
  const { isLoading } = useController();
  return isWebView() || isPWA() ? (
    <div className="mobile-landing-wrapper">
      <Ellipses
        className="mobile-landing-wrapper__ellipses"
        countEllipses={4}
        isMobile={true}
      />
      <AlreadyUsedLink />
      {isLoading ? (
        <div className="link-approve-loader ">
          <BaseSpinner className="link-approve-loader__loader" />
        </div>
      ) : null}
      <div className="mobile-landing-wrapper__sections">
        <MobileAppSectionHeader />
        <MobileAppSectionMainTitle />
      </div>
    </div>
  ) : (
    <div className="landing-wrapper">
      <AlreadyUsedLink />
      {isLoading ? (
        <div className="link-approve-loader ">
          <BaseSpinner className="link-approve-loader__loader" />
        </div>
      ) : null}
      <div className="landing-wrapper__sections">
        <Outlet />
        <SectionFooter />
      </div>
    </div>
  );
}

export default PwaAndAppAuthGuard(LandingPage);
